export type MetaDataGPX = {
    name: string;
    description: string;
    link: LinkGPX | null;
    author: AuthorGPX | null;
    time: string;
};

export type WaypointGPX = {
    name: string;
    symbol: string;
    comment: string;
    description: string;
    latitude: number;
    longitude: number;
    elevation: number | null;
    time: Date | null;
};

export type TrackGPX = {
    name: string;
    comment?: string;
    description?: string;
    src?: string;
    number?: string;
    link?: LinkGPX | null;
    type?: string | null;
    points: PointGPX[];
    distance?: DistanceGPX;
    elevation?: ElevationGPX;
    slopes?: number[];
};

export type RouteGPX = {
    name: string;
    comment?: string;
    description?: string;
    src?: string;
    number?: string;
    link?: LinkGPX | null;
    type?: string | null;
    points: PointGPX[];
    distance?: DistanceGPX;
    elevation?: ElevationGPX;
    slopes?: number[];
};

export type PointGPX = {
    latitude: number;
    longitude: number;
    elevation?: number | null;
    time?: Date | null;
    extensions?: {
        [key: string]: number;
    } | null;
};

export type DistanceGPX = {
    total: number;
    cumulative: number[];
};

export type ElevationGPX = {
    maximum: number | null;
    minimum: number | null;
    positive: number | null;
    negative: number | null;
    average: number | null;
};

export type AuthorGPX = {
    name: string | null;
    email: EmailGPX | null;
    link: LinkGPX | null;
};

export type EmailGPX = {
    id: string | null;
    domain: string | null;
};

export type LinkGPX = {
    href: string | null;
    text: string | null;
    type: string | null;
};

export type ParsedGPX = {
    xml?: Document;
    metadata?: MetaDataGPX;
    waypoints?: WaypointGPX[];
    tracks?: TrackGPX[];
    routes?: RouteGPX[];
};

type ExtractGPXOptions<T extends keyof ParsedGPX> = T extends "tracks" | "routes" ? T : never;

export type GPXOption = ExtractGPXOptions<keyof ParsedGPX>;
